                      
class CustomTabCollection extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $('.custom-nav-title').unbind().click(function(){
        var index = $(this).data('index');
        $('.custom-nav-title').removeClass('active');
        $(this).addClass('active');
        $('.custom-collection-products-list-info').removeClass('active');
        $('.custom-collection-products-list-info[data-index="' + index + '"]').addClass('active');
      });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-tab-collection", CustomTabCollection);

class CustomTabBlog extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');
        var blogarticle = new Swiper(".custom-blog-wrapper-info-"+ this.getAttribute("data-sectionid"), {
          spaceBetween: 19,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 19,
            },
            769:{
              slidesPerView:desktopperview,
              spaceBetween:19,
            }
          }
        });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-tab-blog", CustomTabBlog);

class CustomTabCard extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');
        var cardarticle = new Swiper(".custom-card-wrapper-info-"+ this.getAttribute("data-sectionid"), {
          spaceBetween: 19,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 19,
            },
            769:{
              slidesPerView:desktopperview,
              spaceBetween:19,
            }
          }
        });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-tab-card", CustomTabCard);

class Customrichtext extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      // $('.mobile-custom-read-more').off('click').on('click', function () {
      //     const $this = $(this);
      //     const $wrapper = $this.parents('.custom-content-with-overlay-wrapper');
      //     const $content = $wrapper.find('.custom-content-overlay-content');

      //     $content.toggleClass('custom-readmore-content');

      //     if ($content.hasClass('custom-readmore-content')) {
      //         $this.text('Read More');
      //     } else {
      //         $this.text('Read Less');
      //     }
      // });

      $(document).off('click', '.mobile-custom-read-more').on('click', '.mobile-custom-read-more', function () {
        const $btn = $(this);
        const $wrapper = $btn.closest('.custom-richtext-main-wrapper');
        const $content = $wrapper.find('.custom-readmore-content');
        $content.toggleClass('is-expanded');
        if ($content.hasClass('is-expanded')) {
          $btn.text('Read Less');
        } else {
          $btn.text('Read More');
        }
      });
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-richtext", Customrichtext);

class CustomReviews extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');
        var blogarticle = new Swiper(".custom-reviews-wrapper-info-"+ this.getAttribute("data-sectionid"), {
          spaceBetween: 18,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 18,
            },
            769:{
              slidesPerView:desktopperview,
              spaceBetween:18,
            },
          },
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-reviews", CustomReviews);


  class CustomTextwithIcon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');

        var filterslidercustom = new Swiper(".custom-icon-with-text-swiper-"+ this.getAttribute("data-sectionid"), {
          spaceBetween: 20,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 20,
            },
            768:{
              slidesPerView:desktopperview - 2,
              spaceBetween:0,
            },
            1024:{
              slidesPerView:desktopperview,
              spaceBetween:0,
            }
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        $(this).css({"opacity":"1"});
      };

      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: "0px 0px 300px 0px",
      });

      observer.observe(this);
    }
  }

  customElements.define("custom-text-with-icon", CustomTextwithIcon);



class slideshowBanner extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);



      $(this).css({ opacity: "1" });
      var autoplayspeed = $(this).data("autoplayspeed");
      var autoplay = $(this).data("autoplay");
      var swiper = new Swiper(
        ".slideshow-banner-slider-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: ".slideshow-banner-pagination",
            clickable: true,
          },
          autoplay: {
            enabled: autoplay,
            delay: autoplayspeed,
            disableOnInteraction: false,
          },
          effect: "fade",
          fadeEffect: { crossFade: true },
          virtualTranslate: true,
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("slideshow-banner", slideshowBanner);

$('.mobile_nav_trigger_sublist').unbind().click(function(){
    var navid= $(this).data('navid');
    $(".mobile-nav__trigger[data-navid='" + navid + "']").click();
});

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const thumbSlider = document.querySelector('.thumb-slider');
      const slides = thumbSlider?.querySelectorAll('.swiper-slide');

      if (!thumbSlider || !slides.length) return;

      const galleryThumbs = new Swiper(thumbSlider, {
        slidesPerView: 5,
        spaceBetween: 9,
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 9,
          },
          768: {
            slidesPerView: 7,
            spaceBetween: 9,
          }
        },
        on: {
          init: function () {
            const currentSlidesPerView = this.params.slidesPerView;
            if (slides.length <= currentSlidesPerView) {
              this.el.classList.add('swiper-centered');
            }
          },
        },
      });
                           
      var galleryTop = new Swiper(".main-slider", {
        spaceBetween: 15,
        direction: "horizontal",
        thumbs: {
          swiper: galleryThumbs,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
         },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 9,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,

          },
        },
      });

      document.addEventListener("repositionmainslider", (e) => {
        var index = e.detail.index;
        galleryTop.slideTo(index);
        galleryThumbs.slideTo(index);
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider", CustomSlider);

  var swiper = new Swiper('.upsell-products-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  class AnnouncementContainer extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $('.announcement-close').unbind().click(function(){
        $('.announcement-bar-static').remove();
      });
      
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("announcement-container", AnnouncementContainer);

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("p").forEach(function (p) {
    const text = p.textContent.toLowerCase();

    if (text.includes("availability") && text.includes("business days")) {
      p.remove();
    }
  });
});

 